import { ListData } from '@fi-app/components/items-list/list-data.service';
import { Injector } from '@angular/core';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { ObjectTypes } from '@fi-shared/types';
import { IFormReportQuestionAnswer } from '@fi-app/fi-form/fi-form-report/fi-form-report';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export class FormReportQuestionAttachmentListData extends ListData<IFormReportQuestionAnswer> {
    constructor(injector: Injector, reportItemClickCallback: (item: IFormReportQuestionAnswer) => void) {
        super(injector, true);

        this.MultiSelect = false;
        this.ShowDelete = false;
        this.ShowCheckAll = false;
        this.ShowCheckBox = false;
        this.CanShowLoadMore = false;
        this.ListItemBigPadding = true;
        this.ObjectType = ObjectTypes.Form;

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('colleague'),
                '',
                new ItemsListHeaderProperties('CcmListItem-Name CcmListItem-NoBorder', true, ItemsListElementType.A, {
                    onClick: ($event, data: IFormReportQuestionAnswer) => {
                        $event.stopPropagation();
                        reportItemClickCallback(data);
                    },
                    RowItemClass: 'CcmRowFullWidth',
                }),
                undefined,
                undefined,
                (data) => data.Details[0].FullName,
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.attachments'),
                'MediaBankFileReferencesCount',
                new ItemsListHeaderProperties(
                    'CcmList-Column-Narrow CcmListItem-NoBorder',
                    true,
                    ItemsListElementType.A,
                    {
                        onClick: ($event, data: IFormReportQuestionAnswer) => {
                            $event.stopPropagation();
                            reportItemClickCallback(data);
                        },
                        isRightAligned: true,
                        smallRightPadding: true,
                        RowItemClass: 'CcmRowFullWidth',
                    },
                ),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('form.question_answer_date'),
                '',
                new ItemsListHeaderProperties(
                    'CcmList-Column-Narrow CcmListItem-NoBorder',
                    true,
                    ItemsListElementType.A,
                    {
                        onClick: ($event, data: IFormReportQuestionAnswer) => {
                            $event.stopPropagation();
                            reportItemClickCallback(data);
                        },
                        isRightAligned: true,
                        smallRightPadding: true,
                        RowItemClass: 'CcmRowFullWidth',
                    },
                ),
                undefined,
                undefined,
                (data) => {
                    return injector
                        .get(FiFormatDateService)
                        .formatDate(data.Details[0].AnswerSets[0].CreatedOn, 'date');
                },
            ),
        );
    }
}
